import { render, staticRenderFns } from "./PlayerRound.vue?vue&type=template&id=916dadfe&scoped=true&"
import script from "./PlayerRound.vue?vue&type=script&lang=ts&"
export * from "./PlayerRound.vue?vue&type=script&lang=ts&"
import style0 from "./PlayerRound.vue?vue&type=style&index=0&id=916dadfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "916dadfe",
  null
  
)

export default component.exports